import gql from 'graphql-tag';
import MarketActivity from '../components/MarketActivity/MarketActivity.fragment';
import Area from '../area.fragment';

export const PropertiesSearchResponseError = gql`
    fragment PropertiesSearchResponseError on PropertiesSearchResponseError {
        errors {
            message
        }
    }
`;

export const PropertiesSearchConnection = gql`
    fragment PropertiesSearchConnection on PropertiesSearchConnection {
        pageInfo {
            hasPreviousPage
            hasNextPage
            startCursor
            endCursor
        }
        totalResults
        metaData {
            geoAlias
            geoDescription
            geoName
            geoCountyAreaName
            geoPostalArea
            geoPostTownName
            geoRegionName
            geoOutcode
            geoOutcodes
            geoIncode
            input {
                geoString
                geoIdentifier
            }
        }
        edges {
            cursor
            node {
                uprn
                propertyId
                lastSale {
                    date
                    price
                }
                address {
                    uprn
                    fullAddress
                    postcode
                }
                attributes {
                    bathrooms
                    bedrooms
                    livingRooms
                    propertyType
                    tenure
                }
                saleEstimate {
                    lowerPrice
                    upperPrice
                }
                trackedProperty {
                    isTracked
                    relationship
                }
            }
        }
    }
`;

const HOUSE_PRICES_RESULTS_QUERY = gql`
    query housePricesResults(
        $path: String!
        $geoIdentifier: GeoIdentifier
        $geoString: NonEmptyString
        $houseType: HouseType
        $rangeMonths: MarketActivityWindow
        $after: ID
        $first: PositiveInt
        $fromLastSaleDate: String
        $propertyTypeCode: String
        $sortDirection: String
        $sortOrder: String
        $toLastSaleDate: String
    ) {
        propertiesSearch(
            after: $after
            first: $first
            input: {
                geoIdentifier: $geoIdentifier
                fromLastSaleDate: $fromLastSaleDate
                propertyTypeCode: $propertyTypeCode
                sortDirection: $sortDirection
                sortOrder: $sortOrder
                toLastSaleDate: $toLastSaleDate
            }
        ) {
            ...PropertiesSearchConnection
            ...PropertiesSearchResponseError
        }

        area(geoIdentifier: $geoIdentifier, geoString: $geoString) {
            ...Area
        }

        breadcrumbs(path: $path) {
            text: label
            id: tracking
            href: uri
        }

        marketActivity(
            geoIdentifier: $geoIdentifier
            geoString: $geoString
            houseType: $houseType
            rangeMonths: $rangeMonths
        ) {
            ...MarketActivity
        }

        yearAllActivity: marketActivity(
            geoIdentifier: $geoIdentifier
            geoString: $geoString
            rangeMonths: TWELVE_MONTHS
            houseType: ALL
        ) {
            ...MarketActivity
        }
        yearDetachedActivity: marketActivity(
            geoIdentifier: $geoIdentifier
            geoString: $geoString
            rangeMonths: TWELVE_MONTHS
            houseType: DETACHED
        ) {
            ...MarketActivity
        }
        yearSemiActivity: marketActivity(
            geoIdentifier: $geoIdentifier
            geoString: $geoString
            rangeMonths: TWELVE_MONTHS
            houseType: SEMI_DETACHED
        ) {
            ...MarketActivity
        }
        yearTerracedActivity: marketActivity(
            geoIdentifier: $geoIdentifier
            geoString: $geoString
            rangeMonths: TWELVE_MONTHS
            houseType: TERRACED
        ) {
            ...MarketActivity
        }
        yearFlatActivity: marketActivity(
            geoIdentifier: $geoIdentifier
            geoString: $geoString
            rangeMonths: TWELVE_MONTHS
            houseType: FLAT
        ) {
            ...MarketActivity
        }
    }
    ${MarketActivity}
    ${Area}
    ${PropertiesSearchConnection}
    ${PropertiesSearchResponseError}
`;

export default HOUSE_PRICES_RESULTS_QUERY;
